export default {

    choose: "Válassz",
    now: "Most fizetendő",

    booking: {

        inputs: {
            first_name: {
                label: "Keresztnév",
                placeholder: "Keresztnév (Kötelező)",
            },
            last_name: {
                label: "Vezetéknév",
                placeholder: "Vezetéknév (Kötelező)",
            },
            email: {
                label: "Email",
                placeholder: "Email (Kötelező)",
            },
            phone: {
                label: "Telefon",
                placeholder: "Telefon (Kötelező)",
            },
            hasEuTaxNumAndWantInvoice: {
                label: "Van EU-adószámom és számlát is kérek",
            },
            invoice: {
                eu_tax_number: {
                    label: "EU-adószám",
                    placeholder: "EU-adószám (Kötelező)",
                },
                name: {
                    label: "Név",
                    placeholder: "Név (Kötelező)",
                },
                address: {
                    label: "Cím",
                    placeholder: "Cím (Kötelező)",
                },
                town: {
                    label: "Város",
                    placeholder: "Város (Kötelező)",
                },
                postcode: {
                    label: "Irányítószám",
                    placeholder: "Irányítószám (Kötelező)",
                },
            },
            numberOfGuests: {
                labelReservation: "Ennyien jövünk",
                labelEnquiry: "Ennyien jönnénk",
            },
            requested_single_rooms: {
                label: "Igényelt egyágyas szobák száma",
            },
            note: {
                label: "Megjegyzés",
                placeholder: "Megjegyzés",
            },
            question: {
                label: "Kérdés",
                placeholder: "Kérdés",
            },
        },


        bookAndPay: "Foglalok és fizetek",
        reservation: "Foglalok",
        enquiry: "Érdeklődöm",

        fullPayable: 'Fizetendő',
    },

    stripe: {
        inputs: {
            cardData: {
                label: "Kérlek, itt add meg bankkártya adataidat",
            }
        }
    }

};
